import React, { useState } from "react"
import { CSSTransition } from "react-transition-group"
import { Pound } from "../helpers/currency-filter"
import { StyledGroup, Item, Aside } from "./storegrid-styles"
import PropTypes from "prop-types"
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

const StoreGrid = ({ products }) => {
  const min = 0
  const max = 200
  const [filteredProducts, updateFilteredProducts] = useState(products)
  const [priceRange, updatePriceRange] = useState(max)

  const updateProducts = newPrice => {
    updatePriceRange(newPrice)
    updateFilteredProducts(products.filter(item => item.price < newPrice))
  }

  return (

    <Grid container spacing={2}>
        {filteredProducts.map((item, k) => (
          <Grid key={k} item xs={12} sm={6} md={4} lg={4}>
            <CSSTransition key={item.id} timeout={100} classNames="items">
              <Item>
                <div className="img-contain">
                  <a href={`/product/${item.id}`}>
                    <img src={item.img} alt="" style={{objectFit:"cover", maxHeight:"250px"}}></img>
                  </a>
                </div>
                <h3>{item.name}</h3>
                <Stack direction="row" spacing={3}>
                      {item.was ? <h4 className="wasPrice">Was: {Pound(item.was)}</h4> : null}
                      <h4 className="price">{item.was ? 'Now: ' : null}{Pound(item.price)}</h4>
                </Stack>
                
              </Item>
            </CSSTransition>
          </Grid>
          
        ))}
      
      {/* <div className="storegrid">
      
      <Aside>
        <h3>Filter by Price:</h3>
        <p style={{ marginTop: "5px" }}>
          Max Price <strong>${priceRange}</strong>
        </p>
        <input
          className="slider"
          type="range"
          min={min}
          max={max}
          step={0.1}
          value={priceRange}
          onChange={event => updateProducts(event.target.value)}
        ></input>
        <span className="min">${min}</span>
        <span className="max">${max}</span>
      </Aside>
    </div> */}
    </Grid>
  )
}

StoreGrid.propTypes = {
  products: PropTypes.array,
}

export default StoreGrid
